import React from 'react';
import Navbar from '../components/Navbar'; // Adjust path as needed
import Footer from '../components/Footer'; // Adjust path as needed

const Refund = () => {
  return (
    <>
     
      <Navbar />
	  <center>
      <div
        id="pricing"
		className="text-center justify-content-center align-items-center"
        style={{ fontSize: '15px', width: '50%' }}
      >
		<div className="text-center">
			
			<h1 className="pt-4 text-instagram"><strong>Refund Policy</strong></h1>

			
	  </div>
        <p>
          We offer a 30-day money-back guarantee for our Services. If you are not satisfied with our Services within the first 30 days of your purchase, you may request a full refund by contacting us at{' '}
          <span className="text-instagram">contact@viralgpt.com</span>. Refunds will be processed within 7 business days.
        </p>
      </div>
	  </center>
      <Footer />
    </>
  );
};

export default Refund;
